import { atom } from "recoil";

// current user's profile

const accessControlListState = atom({
    key: "accessControlList",
    default: undefined
});

export default accessControlListState;